import React from "react";

import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";

import {
  AppBar,
  Box,
  IconButton,
  Toolbar,
  Menu,
  MenuItem,
  Button,
  Avatar,
  Divider,
  ListItemIcon,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useAuthStore } from "../../../store/auth";
import userimg from "../../../assets/images/users/user.png";
import { useNavigate } from "react-router-dom";

const Header = ({
  collapsed,
  toggleSidebar,
  toggleMobileSidebar,
  sx,
  customClass,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [scrolled, setScrolled] = React.useState(false);

  const unsetAuthenticated = useAuthStore(
    (state) => state.unsetAuthenticated
  );
  const navigate = useNavigate();

  const theme = useTheme();
  const lgUp = useMediaQuery(theme.breakpoints.up("lg"));

  /* ===== Detect content scroll for shadow ===== */
  React.useEffect(() => {
    const content = document.querySelector("[data-content-scroll]");
    if (!content) return;

    const handleScroll = () => {
      setScrolled(content.scrollTop > 0);
    };

    content.addEventListener("scroll", handleScroll);
    return () => content.removeEventListener("scroll", handleScroll);
  }, []);

  const handleSignOut = () => {
    unsetAuthenticated();
    localStorage.removeItem("access_token");
    navigate("/login");
  };

  return (
    <AppBar
      position="static"
      elevation={0}
      className={customClass}
      sx={{height: 64,                 // ✅ force height
    minHeight: 64,
        backgroundColor: "#ffffff",
        color: "#000",

        /* Light bottom border */
        borderBottom: "1px solid rgba(0,0,0,0.08)",

        /* Shadow only on scroll */
        boxShadow: scrolled
          ? "0px 2px 6px rgba(0,0,0,0.08)"
          : "none",

        transition: "box-shadow 200ms ease",

        ...sx,
      }}
    >
      <Toolbar>
        {/* ===== MOBILE MENU ===== */}
        {!lgUp && (
          <IconButton
            color="inherit"
            onClick={toggleMobileSidebar}
          >
            <MenuOutlinedIcon />
          </IconButton>
        )}

        {/* ===== DESKTOP SIDEBAR TOGGLE ===== */}
        {lgUp && (
          <IconButton
            onClick={toggleSidebar}
            sx={{
              mr: 1,
              color: collapsed
                ? theme.palette.text.secondary
                : theme.palette.primary.main,
              transition: "color 200ms ease",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                transform: collapsed
                  ? "rotate(180deg)"
                  : "rotate(0deg)",
                transition:
                  "transform 300ms ease, color 200ms ease",
              }}
            >
              <ChevronLeftIcon />
            </Box>
          </IconButton>
        )}

        <Box flexGrow={1} />

        {/* ===== PROFILE ===== */}
        <Button
          color="inherit"
          onClick={(e) => setAnchorEl(e.currentTarget)}
        >
          <Box display="flex" alignItems="center">
            <Avatar
              src={userimg}
              sx={{ width: 30, height: 30 }}
            />
            <Typography variant="h6" sx={{ ml: 1 }}>
              Instablood Admin
            </Typography>
          </Box>
        </Button>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          sx={{
            "& .MuiMenu-paper": {
              width: 250,
              mt: 1,
            },
          }}
        >
          <MenuItem disabled>
            <Avatar sx={{ width: 35, height: 35, mr: 2 }} />
            Instablood Admin
          </MenuItem>

          <Divider />

          <MenuItem onClick={handleSignOut}>
            <ListItemIcon>
              <LogoutOutlinedIcon fontSize="small" />
            </ListItemIcon>
            Logout
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
